import { Button } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Wrapper = styled.div`
    padding: 1rem 0.6rem;
    width: 100%;
`

export const CustomButtonPrint = styled(Button)`
    background: ${theme.colors.green2} !important;
    width: 20rem;
    height: 3rem !important;
    margin: 0 !important;
    &:disabled {
        background: ${theme.colors.gray} !important;
    }
`

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.6rem;
    margin-top: 1rem;
`

export const PrintArea = styled.div`
    display: none;

    @media print {
        display: block;
    }
`

export const PrintPage = styled.div`
    @page{
        size: landscape;
        margin: 10px;
    }
    page-break-before: always;
`

export const CustomButton = styled(ButtonMui)`
    width: 12rem;    
    height: 3rem !important;
    margin: 0 !important;
`
